(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[183],{

/***/ 34166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m15 18-6-6 6-6"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronLeft);

/***/ }),

/***/ 76058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m9 18 6-6-6-6"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronRight);

/***/ }),

/***/ 82110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18 6 6 18M6 6l12 12"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCross);

/***/ }),

/***/ 52409:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category",
      function () {
        return __webpack_require__(37694);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ category; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/Seo.tsx
var Seo = __webpack_require__(68661);
// EXTERNAL MODULE: ../../node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(48657);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../packages/ui/src/link/Link.tsx
var Link = __webpack_require__(48994);
;// CONCATENATED MODULE: ./src/features/category/components/desktop-categories-nav/DesktopCategoriesNav.tsx




function DesktopCategoriesNav(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "475d785823580a67",
                children: ".desktop-categories.jsx-475d785823580a67>:first-child{margin-top:0}"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-475d785823580a67" + " " + "desktop-categories container my-16 hidden gap-8 space-y-8 md:block md:columns-2 lg:columns-3",
                /*#__PURE__*/ children: categories.map(function(category) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                        itemType: "category",
                        item: category
                    }, category.title);
                })
            })
        ]
    });
}
function NavItem(param) {
    var itemType = param.itemType, item = param.item;
    var hrefBase = itemType === "category" ? "/hire" : "/brand";
    // If leaf node (or brand since brand is always a leaf node), just render link
    if (itemType === "brand" || !item.children || item.children.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "".concat(hrefBase, "/").concat(item.href),
            prefetch: false,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                className: "text-gray-800 no-underline",
                children: [
                    item.title,
                    " \u2192"
                ]
            })
        });
    }
    // Otherwise, recursively render another category
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-4 break-inside-avoid rounded-lg border p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat(hrefBase, "/").concat(item.href),
                prefetch: false,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    className: "font-medium text-black no-underline",
                    children: item.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-2",
                children: item.children.sort(function(child) {
                    return child.children && child.children.length > 0 ? 1 : -1;
                }).map(function(child) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "truncate",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                            itemType: "category",
                            item: child
                        })
                    }, child.title);
                })
            }),
            item.__typename === "NavigationTopCategory" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-4 font-medium text-black",
                        children: "Popular brands"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt-2",
                        children: item.popularBrands.map(function(child) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "truncate",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                    itemType: "brand",
                                    item: child
                                })
                            }, child.title);
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/assets/icons/chevron-left.svg
var chevron_left = __webpack_require__(34166);
// EXTERNAL MODULE: ../../packages/assets/icons/chevron-right.svg
var chevron_right = __webpack_require__(76058);
// EXTERNAL MODULE: ../../packages/assets/icons/cross.svg
var cross = __webpack_require__(82110);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ./src/hooks/use-hash.ts


function useHash() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(), hash = ref[0], setHash = ref[1];
    (0,react.useEffect)(function() {
        var onHashChangeStart = function onHashChangeStart(url) {
            setHash(url.split("#")[1]);
        };
        // Fire once to update on mount
        onHashChangeStart(window.location.href);
        router.events.on("hashChangeStart", onHashChangeStart);
        return function() {
            router.events.off("hashChangeStart", onHashChangeStart);
        };
    }, [
        router.events
    ]);
    return hash;
}

;// CONCATENATED MODULE: ./src/features/category/helpers/get-categories-map.ts
function getCategoriesMap(categories) {
    var map = new Map();
    function traverseCategory(category, parent) {
        var ref;
        Object.assign(category, {
            parentHref: parent === null || parent === void 0 ? void 0 : parent.href
        });
        map.set(category.href, category);
        (ref = category.children) === null || ref === void 0 ? void 0 : ref.forEach(function(child) {
            return traverseCategory(child, category);
        });
    }
    categories.forEach(function(category) {
        return traverseCategory(category, undefined);
    });
    return map;
}

;// CONCATENATED MODULE: ./src/features/category/components/mobile-categories-nav/MobileCategoriesNav.tsx









function MobileCategoriesNav(param) {
    var categories = param.categories;
    var selectedHref = useHash();
    var categoriesMap = (0,react.useMemo)(function() {
        return getCategoriesMap(categories);
    }, [
        categories
    ]);
    var selected = categoriesMap.get(selectedHref);
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "\n        @media screen and (max-width: 768px) {\n          #header,\n          #header-promo-bar,\n          #footer {\n            display: none;\n          }\n        }\n      "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sticky top-0 flex items-center justify-between border-b bg-white p-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (selected === null || selected === void 0 ? void 0 : selected.parentHref) ? "#".concat(selected.parentHref) : "/category",
                                shallow: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: classnames_default()(!selected && "invisible"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Back"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_left/* default */.Z, {
                                            className: "h-5 w-5"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "font-medium tracking-wide",
                                children: (ref = selected === null || selected === void 0 ? void 0 : selected.title) !== null && ref !== void 0 ? ref : "Categories"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cross/* default */.Z, {
                                            className: "h-5 w-5"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "space-y-8 pt-2 pb-8",
                        children: [
                            selected && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/hire/".concat(selected.href),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "mx-4 flex border-b py-2.5 text-sm text-gray-800",
                                    children: "View all"
                                })
                            }),
                            (selected === null || selected === void 0 ? void 0 : selected.featured) && selected.featured.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavSection, {
                                title: "Featured categories",
                                itemType: "category",
                                items: selected === null || selected === void 0 ? void 0 : selected.featured
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavSection, {
                                title: selected && "All categories",
                                itemType: "category",
                                items: (ref1 = selected === null || selected === void 0 ? void 0 : selected.children) !== null && ref1 !== void 0 ? ref1 : categories
                            }),
                            (selected === null || selected === void 0 ? void 0 : selected.__typename) === "NavigationTopCategory" && selected.featured.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavSection, {
                                title: "Popular brands",
                                itemType: "brand",
                                items: selected === null || selected === void 0 ? void 0 : selected.popularBrands
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function NavSection(param) {
    var title = param.title, itemType = param.itemType, items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "px-4",
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-lg font-medium",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                children: items.map(function(category) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileCategoriesNav_NavItem, {
                        itemType: itemType,
                        item: category
                    }, category.href);
                })
            })
        ]
    });
}
function MobileCategoriesNav_NavItem(param) {
    var itemType = param.itemType, item = param.item;
    var hrefBase = itemType === "category" ? "/hire" : "/brand";
    var hasChildren = "children" in item;
    var isLeafNode = !hasChildren || item.children && item.children.length === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: isLeafNode ? "".concat(hrefBase, "/").concat(item.href) : "#".concat(item.href),
        shallow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "flex items-center justify-between truncate border-b py-3 text-sm text-gray-800",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: item.title
                }),
                !isLeafNode && /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {
                    className: "h-4 w-4"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/category.tsx




function CategoryPage(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* Seo */.p, {
                templateTitle: "Categories"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopCategoriesNav, {
                categories: categories
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileCategoriesNav, {
                categories: categories
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ var category = (CategoryPage);


/***/ }),

/***/ 48994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78707);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var DEFAULT_ELEMENT = "a";
var variants = {
    primary: "text-mid-green ring-mid-green/25",
    neutral: "text-gray-500 ring-gray-500/25",
    unstyled: null
};
var Link = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var as = _param.as, children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _isSubtle = _param.isSubtle, isSubtle = _isSubtle === void 0 ? false : _isSubtle, _isStrong = _param.isStrong, isStrong = _isStrong === void 0 ? false : _isStrong, className = _param.className, props = _objectWithoutProperties(_param, [
        "as",
        "children",
        "variant",
        "isSubtle",
        "isStrong",
        "className"
    ]);
    var Component = as || DEFAULT_ELEMENT;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _objectSpread({}, props, {
        ref: ref,
        className: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .cnm */ .w)("\n            rounded-sm ring-mid-green/25 transition hover:underline focus:underline\n            focus-visible:outline-none focus-visible:ring-4\n          ", variant && variants[variant], !isSubtle && "underline", isStrong && "font-medium", className),
        children: children
    }));
});



/***/ }),

/***/ 78707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ cnm; }
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67579);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function cnm() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_1__/* .twMerge */ .m)(classnames__WEBPACK_IMPORTED_MODULE_0___default().apply(void 0, _toConsumableArray(classes)));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7164,9097,8657,9774,2888,179], function() { return __webpack_exec__(52409); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);